import { from } from 'rxjs';
import { ISupplierRegistration, Sections, UserInfoSectionFields, DMConstants } from '@nexxe/bn-registration-core-services'
import { Injectable, ChangeDetectorRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { LocalizationService } from '@nexxe/shared';
// import { Subject } from 'rxjs/Subject';
import { ChannelService, DmDataModelManagerService, DmWidgetManagerService, Message } from '@nexxe/core';
import { coreVendors } from '@nexxe/core-vendors';
import { ConfigurableDataSourceService } from '@nexxe/cds';
import * as _ from 'lodash';

interface ISubmitButtonActivateFlag {
    SubmitButtonActivateFlagUN?: boolean;
    SubmitButtonActivateFlagFN?: boolean;
    SubmitButtonActivateFlagLN?: boolean;
    SubmitButtonActivateFlagLCN?: boolean;
    SubmitButtonActivateFlagEmail?: boolean;
    SubmitButtonActivateFlagPass?: boolean;
}
declare var userInfo: any;

@Injectable()
export class CustomerInfoEntryService {
    public currentProject: any;
    public currentProjectMetaData: any;
    private passwordFieldId: string = "password";
    private confirmPasswordFieldId: string = "confirmPassword";
    private confirmPasswordFlagName: string = "confirmPasswordDoesNotMatch";
    private defaultManagerId: string = Sections.DefaultRegistrationManagerId;
    private userInfoWidgetId: string = Sections.UserInfoRegistration;
    public customErrors: any;
    public passwordRegex: RegExp;
    public emailRegex: RegExp;
    public legalCompanyNameRegex: RegExp;
    private popupConfig: any;
    /// add custom errors
    constructor(private http: HttpClient,
        private dataModelService: DmDataModelManagerService,
        private dmWidgetManagerService: DmWidgetManagerService,
        private cdsService: ConfigurableDataSourceService,
        private cdRef: ChangeDetectorRef,
        public channelService: ChannelService,
        private dmConstants: DMConstants,
        private localizationService: LocalizationService,) {
        /// add custom errors
        this.customErrors = {};
        //this.customErrors["userNameExists"] = false;
        this.customErrors["confirmPasswordDoesNotMatch"] = false;
        // this.customErrors["invalidUserName"] = false;
        this.passwordRegex = new RegExp("^(?=.*\\d)(?=.*[a-z])(?=.*[!@#$%^&*()_+?])(?=.*[A-Z])(?!.*\\s)(?!.*[^!@#$%^&*()_+?A-Za-z0-9]).{10,20}$");
        this.emailRegex = /^(?![.])^(?!@)(?!.*@@)(?!.*@.*@)(?!.*\.\.)([a-zA-Z0-9\-_.!#$%&'*+\/=?^`{|}~])*@(([a-zA-Z0-9\-_])+(\.))+((([a-zA-Z])?([a-zA-Z])))+$/;

        this.legalCompanyNameRegex= new RegExp("(<([^>]+)>)");
        //this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId, "Category", ['type'], "");
    }

    private getDataModel(event: any) {
        var datapath = event.target.id.split('_');
        var field = this.dmWidgetManagerService.getFieldById(datapath[0], datapath[1], datapath[2]);
        var model = this.dataModelService.getIn(field.dataModelId, field.data.split("."));
        return model;
    }

    emptyCheckFirstName(event: any) {
        var model = this.getDataModel(event);
        if ((model) && (model.length) >= 0) {
            this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId, UserInfoSectionFields.FirstName, ['validation', 'message'], '');
            this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagFN"],true);
        } else {
            this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId, UserInfoSectionFields.FirstName, true, this.localizationService.translate("SN_Registration_FirstNameMissing"));
            this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagFN"],false);
        }
        this.cdRef.detectChanges();
        // To reset captcha in case of direct link only
        if(userInfo.IsDirectLink || !userInfo.IsInvited){
            this.resetCaptcha();
        }
    }

    emptyCheckLastName(event: any) {
        var model = this.getDataModel(event);
        if ((model) && (model.length) >= 0) {
            this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId, UserInfoSectionFields.LastName, ['validation', 'message'], '');
            this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagLN"],true);
        } else {
            this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId, UserInfoSectionFields.LastName, true, this.localizationService.translate("SN_Registration_LastNameMissing"));
            this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagLN"],false);
        }
        this.cdRef.detectChanges();
        // To reset captcha in case of direct link only
        if(userInfo.IsDirectLink || !userInfo.IsInvited){
            this.resetCaptcha();
        }
    }
    emptyCheckLegalCompanyName(event: any) {
        var model = this.getDataModel(event);
        if ((model) && (model.length) >= 0) {
            this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId, UserInfoSectionFields.LegalCompanyName, ['validation', 'message'], '');
            this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagLCN"],true);
            // legal company name entered, check if email entered
            let userInfoData: ISupplierRegistration = this.dataModelService.getById(Sections.UserInfoRegistration);
            if (userInfoData && userInfoData.userInfo && userInfoData.userInfo.emailAddress) {
                //legal company name + email present, call API
                //this.dmWidgetManagerService.setInField(Sections.DefaultRegistrationManagerId, Sections.UserInfoRegistration, UserInfoSectionFields.Country, ['attributes', 'disable'], false);
                //this.dmWidgetManagerService.setInField(Sections.DefaultRegistrationManagerId, Sections.UserInfoRegistration, UserInfoSectionFields.Category, ['attributes', 'disable'], false);
                if (!this.legalCompanyNameRegex.test(model)) {
                    this.dataModelService.setIn("CompanyProfile_CO", ['CompanyOverview', 'BasicDetails', 'supplierLegalName'], '');
               // disabling on temporary basis for bofa client
                    // this.checkDuplicateProfiles(userInfoData.userInfo.emailAddress, model);
                //this.showPopup();
                }
            }
        } else {
            this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId, UserInfoSectionFields.LegalCompanyName, true, this.localizationService.translate("SN_Registration_CompanyNameMissing"));
            this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagLCN"],false);
        }
        this.cdRef.detectChanges();
        // To reset captcha in case of direct link only
        if(userInfo.IsDirectLink || !userInfo.IsInvited){
            this.resetCaptcha();
        }
    }
    emptyCheckEmail(event: any) {
        var model = this.getDataModel(event);
        if ((model) && (model.length) >= 0) {
            this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId, UserInfoSectionFields.UserEmail, ['validation', 'message'], '');
            if (!this.emailRegex.test(model)) {
                this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId, UserInfoSectionFields.UserEmail, true, this.localizationService.translate("SN_Registration_InvalidEmailFormat"));
                this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagEmail"],false);
            } else {
                this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId, UserInfoSectionFields.UserEmail, ['validation', 'message'], '');
                this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagEmail"],true);
                // email (in correct format) entered, check if legal company name entered
                let userInfoData: ISupplierRegistration = this.dataModelService.getById(Sections.UserInfoRegistration);
                if (userInfoData && userInfoData.userInfo && userInfoData.userInfo.legalCompanyName) {
                    //legal company + email present, call API
                    //this.dmWidgetManagerService.setInField(Sections.DefaultRegistrationManagerId, Sections.UserInfoRegistration, UserInfoSectionFields.Country, ['attributes', 'disable'], false);
                    //this.dmWidgetManagerService.setInField(Sections.DefaultRegistrationManagerId, Sections.UserInfoRegistration, UserInfoSectionFields.Category, ['attributes', 'disable'], false);
                    if (!this.legalCompanyNameRegex.test(userInfoData.userInfo.legalCompanyName)) {
                        this.dataModelService.setIn("CompanyProfile_CO", ['CompanyOverview', 'BasicDetails', 'supplierLegalName'], '');
                        this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagLCN"],true);
                                      // disabling on temporary basis for bofa client

                        // this.checkDuplicateProfiles(model, userInfoData.userInfo.legalCompanyName);
                        //this.showPopup();
                    }
                }
            }
        } else {
            this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId, UserInfoSectionFields.UserEmail, true, this.localizationService.translate("SN_Registration_EmailMissing"));
            this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagEmail"],false);
        }
        this.cdRef.detectChanges();
        // To reset captcha in case of direct link only
        if(userInfo.IsDirectLink || !userInfo.IsInvited){
            this.resetCaptcha();
        }
    }

    /// user info - on confirm pasword change
    eventOnConfirmPasswordChange(confPasswordVal): void {
        this.performPasswordValidations(this.confirmPasswordFieldId, this.passwordFieldId);
    }

    // when password change.
    eventOnPasswordChange(passwordValu): void {
        this.performPasswordValidations(this.passwordFieldId, this.confirmPasswordFieldId);
    }
    // sets widget field error message.
    performPasswordValidations(currentField: string, correspondingField: string) {
        let userInfoData: ISupplierRegistration = this.dataModelService.getById(Sections.UserInfoRegistration);
        this.customErrors[this.confirmPasswordFlagName] = false;
        if ((userInfoData && userInfoData.userInfo)) {
            if (userInfoData.userInfo[currentField] && userInfoData.userInfo[currentField] != '') {
                this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId, currentField, ['validation', 'message'], '');
                if (!this.passwordRegex.test((userInfoData.userInfo[currentField]))) {
                    this.customErrors[this.confirmPasswordFlagName] = true;
                    this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId, currentField, true, this.localizationService.translate("SN_Registration_PasswordPolicyError"));
                    //to set flag false for submit buttton enable event
                    this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagPass"],false);
                    
                } else {
                    if (userInfoData.userInfo[correspondingField] && userInfoData.userInfo[correspondingField] != '') {
                        if ((userInfoData.userInfo[currentField]) !== (userInfoData.userInfo[correspondingField])) {
                            this.customErrors[this.confirmPasswordFlagName] = true;
                            this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId, currentField, true, this.localizationService.translate("SN_Registration_CnfPasswordPolicyError"));
                            this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagPass"],false);
                        } else {
                            this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId, correspondingField, ['validation', 'message'], '');
                            this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagPass"],true);
                        }
                    }
                }

            } else {
                if(currentField == "password"){
                    this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId, currentField, true, this.localizationService.translate("BN_Registration_PasswordNewMsg"));
                    this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagPass"],false);

                }else{
                    this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId, currentField, true, this.localizationService.translate("BN_Registration_ConfirmPasswordNewMsg"));
                    this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagPass"],false);

                }
            }
        } else {
            this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId, currentField, ['validation', 'message'], '');
            this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagPass"],true);
        }
        this.cdRef.detectChanges();
        // To reset captcha in case of direct link only
        if(userInfo.IsDirectLink || !userInfo.IsInvited){
            this.resetCaptcha();
        }
    }

    // event keyup for Country
    onCountryAutoSuggestKeyUp: any = coreVendors.lodash.debounce(this.onCountryAutoSuggestChange, 300);

    // event ngModelChange for Username
    async eventUserNameModelChange(event) {
        var validateUserbool: any;
        var model = this.getDataModel(event);
        let userNameRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9@'-._//\\/g]{6,50}$/;
        let format = /[!#$%^&*()+=\[\]{};:"|,<>?]+/;
        if (model && model.length > 0) {
            //check for Regex Validation
            if (format.test(model)) {
                this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId,
                    "UserName", true, this.localizationService.translate("SN_Registration_UserNameValidation"));
                this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],false);
                this.cdRef.detectChanges();
            }
            else if (!userNameRegex.test(model)) {
                this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId,
                    "UserName", true, this.localizationService.translate("SN_Registration_UserNamePolicyError"));
                this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],false);
                this.cdRef.detectChanges();
            } else {
                //this only happens in case of invited and self 
                // In case of direct link this call happens after recaptcha/submit 
                if (!userInfo.IsDirectLink) {
                    //if Regex valid, check if unused Username through API
                    if (this.dmConstants.isInvited) {
                        try {
                            this.callGlobalLoader("loadderstart");
                            validateUserbool = await this.checkDuplicateUsernameNew(model);
                            let userInfoData = this.dataModelService.getById("UserInfoRegistration");
                            userInfoData.userInfo.validateUser = validateUserbool.store;
                            this.callGlobalLoader("loadderEnd");
                        }
                        catch (ex) {
                            this.callGlobalLoader("loadderEnd");
                        }
                        this.ExisingUserEmailPCCheckNew(model);
                    }
                    else {
                        this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId,
                            "UserName", ['validation', 'message'], '');
                        this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],true);
                    }
                }
                else {
                    this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId,
                        "UserName", ['validation', 'message'], '');
                    this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],true);
                }
            }
        } else {
            this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId,
                "UserName", true, this.localizationService.translate("SN_Registration_UserNameMissing"));
            this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],false);
            this.cdRef.detectChanges();
        }
        // To reset captcha in case of direct link only
        if(userInfo.IsDirectLink || !userInfo.IsInvited){
            this.resetCaptcha();
        }
    }

    checkDuplicateUsername(model){ 
        let payload = {
            "UserId": 0,
            "UserName": model.trim()
        };
        this.cdsService.request({
            keys: "validateUser",
            version: 1,
            override: true,
            contexts: { data: payload}
          }).subscribe(data => {
            if (data) {
                let userInfoData = this.dataModelService.getById("UserInfoRegistration");
                userInfoData.userInfo.validateUser= data.store; 
                if (data.store) {
                    // valid username
                    // restore validation error
                    this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId,
                        "UserName", ['validation', 'message'], '');
                    this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],true);
                } else {
                    // show validation error
                    // if (this.dmConstants.isInvited) {
                    //     this.callNotification("dublicateUserName");
                    // } else {
                        this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId,
                             "UserName", true, this.localizationService.translate("SN_Registration_UserNameAlreadyExists_OnValidate"));
                        this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],false);
                    // }
                }
                this.cdRef.detectChanges();
            } else {
                console.log("Error Validate User");
            }
        });
    }

    checkDuplicateUsernameNew(model):any{
        let payload = {
            "UserId": 0,
            "UserName": model.trim()
        };
        return this.cdsService.request({
            keys: "validateUser",
            version: 1,
            override: true,
            contexts: { data: payload}
        }).toPromise()
    }

    getEmailCheck(model){
        let userInfoData: ISupplierRegistration = this.dataModelService.getById(Sections.UserInfoRegistration);
        this.cdsService.request({
            keys: "checkusernameEmail",
            version: 1,
            override: true,
            contexts: { username:  model}
          }).subscribe(data => {
            if (data) {
                if (data.store && data.store.userBasicDetails && data.store.userBasicDetails.userId != null && data.store.userBasicDetails.emailAddress.trim().toLowerCase() != userInfoData.userInfo.emailAddress.trim().toLowerCase()) {
                    this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId,
                        "UserName", true, this.localizationService.translate("SN_Registration_UserNameAlreadyExists_OnValidate"));
                    this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],false);
                 }
                else if (data.store && data.store.userBasicDetails && data.store.userBasicDetails.userId != null && data.store.userBasicDetails.emailAddress.trim().toLowerCase() == userInfoData.userInfo.emailAddress.trim().toLowerCase()) {
                    this.callNotification("dublicateUserName");
                    this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],true);
                } else {
                    this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId,
                        "UserName", ['validation', 'message'], '');
                    this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],true);
                }
                this.cdRef.detectChanges();
            } else {
                console.log("Error Validate User");
            }
        });
    }

    //Exising Username link while registration -- email and PC check with respect to bpc (new API)
    ExisingUserEmailPCCheckNew(model){
        let userInfoData: ISupplierRegistration = this.dataModelService.getById(Sections.UserInfoRegistration);
        this.cdsService.request({
            keys: "exisingUserEmailPCCheckNew",
            version: 1,
            override: true,
            contexts: { username:  model.trim(),
                email:userInfoData.userInfo.emailAddress.trim().toLowerCase(),
                spc:this.dmConstants.supplierBuyerMappingInfo.supplierPartnerCode,
                bpc:this.dmConstants.supplierBuyerMappingInfo.buyerPartnerCode}
          }).subscribe(data => {
            if (data) {
                if(userInfo.EnableUserNameAsEmailFeatureSetting && userInfo.BuyerInvitationDetails.MultiUserNameExists){
                    if (data.store == "false") {
                        this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId,
                            "UserName", true, this.localizationService.translate("SN_Registration_NewUserNameInvalid_OnValidate"));
                        this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],false);
                     }
                    else if (data.store == "true") {
                        this.callNotification("dublicateUserName");
                        this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],true);
                    } else {
                        this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId,
                            "UserName", true, this.localizationService.translate("SN_Registration_NewUserNameInvalid_OnValidate"));
                        this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],false);
                    }
                    this.cdRef.detectChanges();
                }
                else if(userInfo.EnableUserNameAsEmailFeatureSetting && userInfo.BuyerInvitationDetails.SingleUserNameExists){
                    if (data.store == "false") {
                        this.callNotification("apiError");
                     }
                    else if (data.store == "true") {
                        this.callNotification("UseSingleUserName");
                        this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],true);
                    } else {
                        this.callNotification("apiError");
                    }
                    this.cdRef.detectChanges();
                }
                else{
                    if (data.store == "false") {
                        this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId,
                            "UserName", true, this.localizationService.translate("SN_Registration_UserNameAlreadyExists_OnValidate"));
                        this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],false);
                     }
                    else if (data.store == "true") {
                        this.callNotification("dublicateUserName");
                        this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],true);
                    } else {
                        this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId,
                            "UserName", ['validation', 'message'], '');
                            this.dataModelService.setIn("SubmitButtonActivateFlag",["SubmitButtonActivateFlagUN"],true);
                    }
                    this.cdRef.detectChanges();
                }
            } else {
                console.log("Error Validate User");
            }
        });
    }

    // event ngModelChange for Country
    eventCountryModelChange(model) {
        if (model && model.code && model.value) {
            this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId,
                "Country", ['validation', 'message'], '');
        }
        this.cdRef.detectChanges();
    }

    // event ngModelChange for Category
    onCategorySelect(model) {
        if (model && model.length > 0) {
            this.dmWidgetManagerService.setInField(this.defaultManagerId, this.userInfoWidgetId,
                "Category", ['validation', 'message'], '');
        } else {
            this.dmWidgetManagerService.setFieldValidity(this.defaultManagerId, this.userInfoWidgetId,
                "Category", true, this.localizationService.translate("SN_Registration_ValueMissing"));
        }
        this.cdRef.detectChanges();
    }

    onDeactivate(e, widgetParams) {
        //debugger;
    }

    testdeactivate(e){
console.log(e);
    }

    testblur(e){
        console.log(e);
    }

    onCountryAutoSuggestChange(e, widgetParams) {
        if (e && e.target.value != '' && e.keyCode !== 38 && e.keyCode !== 40) {
            this.getCountryOptions(e.target.value).subscribe(data => {
                if (data && data.store && data.store.isSuccess && data.store.returnValue) {
                    this.setCountryOptions(data.store.returnValue, widgetParams);
                }
            });
        }
    }
    getCountryOptions(searchText: string, fetchCount: number = 10): Observable<any> {
        let params = {
            "metaDataTypeId": 1,
            "search": encodeURIComponent(searchText),
            "pageNumber": 1,
            "pageSize": fetchCount
        };
        return this.cdsService.request({
            keys: "getMDMCountries",
            version: 1,
            override: true,
            contexts: { metaDataTypeId: 1,
            search: encodeURIComponent(searchText),
            pageNumber: 1,
            pageSize: fetchCount}
          })
    }

    setCountryOptions(data: any, widgetParams: any) {
        let dataArr: Array<any> = [];
        if (data && data.masterRecords && data.masterRecords.length > 0) {
            data.masterRecords.forEach((element) => {
                dataArr.push({ code: element['code'], value: element['name'] });
            });
        }

        if (dataArr.length > 0) {
            this.dmWidgetManagerService.setFieldOptions(widgetParams.managerId, widgetParams.widgetId,
                widgetParams.fieldId, coreVendors.lodash.cloneDeep(dataArr));
        }
    }


    /// get section default data
    getSectionDefaultData(section: Sections) {

        /// check
        switch (section) {

            case Sections.UserInfoRegistration: {
                return <ISupplierRegistration>{
                    userInfo: {
                        firstName: null,
                        lastName: null,
                        userName: null,
                        password: null,
                        emailAddress: null,
                        confirmPassword: null,
                        legalCompanyName: null,
                        userInfoRegistrationMsg: null,
                        useExistingUserId: false,
                        isdCode: {
                            id: null,
                            key: null
                        },
                        mobileNo: null
                    }
                };
            }

        }
    }
    //# endregion  
    getSectionsModelData(): Observable<any> {
        /// set model data..
        let registrationModel: ISupplierRegistration = this.getSectionDefaultData(Sections.UserInfoRegistration);
        let SubmitButtonActivateFlag: ISubmitButtonActivateFlag = {
            SubmitButtonActivateFlagUN: true,
            SubmitButtonActivateFlagLN: true,
            SubmitButtonActivateFlagFN: true,
            SubmitButtonActivateFlagLCN: true,
            SubmitButtonActivateFlagEmail: true,
            SubmitButtonActivateFlagPass: true
        }
        this.dataModelService.registerDataModel("SubmitButtonActivateFlag",SubmitButtonActivateFlag,true);
        /// register data model...
        this.dataModelService.registerDataModel(Sections.UserInfoRegistration, registrationModel, true);

        /// return..
        return of(registrationModel);
    }
    loadPartnerdata() {
        // this.dmConstants.IsSupplierProfileExists = true;
        // this.dmConstants.isInvited = true;
        if (this.dmConstants.partnerInfo
            && this.dmConstants.partnerInfo.partnerData) {
            //  this.callGlobalLoader("loadderstart");
            // this.getPartnerData().subscribe(data => {
            //     if (data && data.store) {
            //         console.log("sucess");
            //         /// set master data...
            //         this.dmConstants.supplierBuyerMappingInfo.partnerData = data.store ? data.store.partnerData : null;  
            this.dmConstants.supplierBuyerMappingInfo.supplierPartnerCode = this.dmConstants.partnerInfo.partnerData.SPC ? this.dmConstants.partnerInfo.partnerData.SPC : 0;
            this.dmConstants.supplierBuyerMappingInfo.buyerPartnerCode = this.dmConstants.partnerInfo.partnerData.BPC ? this.dmConstants.partnerInfo.partnerData.BPC : 0;
            this.dmConstants.supplierBuyerMappingInfo.supplierContactCode = this.dmConstants.partnerInfo.partnerData.SCC ? this.dmConstants.partnerInfo.partnerData.SCC : 0;
            this.loadSecondaryDetails();
            this.callGlobalLoader("loadderEnd");
            //     } else {
            //         console.log("Error Validate User");
            //         this.callGlobalLoader("loadderEnd");
            //         this.callNotification("error");
            //     }
            // });
        } else {
            this.callGlobalLoader("loadderEnd");
        }

    }
    getPartnerData(): Observable<any> {
        /// set params..
        let params = {
            bpc: this.dmConstants.supplierBuyerMappingInfo.buyerPartnerCode,
            cl: this.dmConstants.supplierBuyerMappingInfo.culture,
            spc: this.dmConstants.supplierBuyerMappingInfo.supplierPartnerCode,
            scc: this.dmConstants.supplierBuyerMappingInfo.supplierContactCode
        };

        /// call
        return this.cdsService.request({
            keys: "getPartnerData",
            version: 1,
            override: true,
            contexts: { bpc: this.dmConstants.supplierBuyerMappingInfo.buyerPartnerCode,
                cl: this.dmConstants.supplierBuyerMappingInfo.culture,
                spc: this.dmConstants.supplierBuyerMappingInfo.supplierPartnerCode,
                scc: this.dmConstants.supplierBuyerMappingInfo.supplierContactCode}
          })

    }
    loadSecondaryDetails() {
        /// append SupplierBuyerMappingInfo data...
        /// append PartnerInfo data...
        this.appendModelData();
        /// remove visibility of few fields if the secondary contact is invited
        if (this.dmConstants.IsSupplierProfileExists && this.dmConstants.isInvited) {
            this.dmWidgetManagerService.setInField(Sections.DefaultRegistrationManagerId, Sections.UserInfoRegistration, UserInfoSectionFields.LegalCompanyName, ['validation', 'message'], '');
           // this.dmWidgetManagerService.setInField(Sections.DefaultRegistrationManagerId, Sections.UserInfoRegistration, UserInfoSectionFields.Country, ['validation', 'message'], '');
           // this.dmWidgetManagerService.setInField(Sections.DefaultRegistrationManagerId, Sections.UserInfoRegistration, UserInfoSectionFields.Category, ['validation', 'message'], '');
            this.dmWidgetManagerService.mandateField(Sections.DefaultRegistrationManagerId, Sections.UserInfoRegistration, UserInfoSectionFields.LegalCompanyName, false);
           // this.dmWidgetManagerService.mandateField(Sections.DefaultRegistrationManagerId, Sections.UserInfoRegistration, UserInfoSectionFields.Country, false);
           // this.dmWidgetManagerService.mandateField(Sections.DefaultRegistrationManagerId, Sections.UserInfoRegistration, UserInfoSectionFields.Category, false);
        }
    }
    /// check SupplierBuyerMappingInfo data
    async appendModelData() {
        /// check for some constraints
        if (this.dmConstants.partnerInfo
            && this.dmConstants.partnerInfo.partnerData
            && this.dmConstants.partnerInfo.partnerData.Contacts
            && this.dmConstants.partnerInfo.partnerData.Contacts[0]
            && !_.isNull(this.dmConstants.partnerInfo.partnerData.Contacts[0].FirstName)
            && !_.isUndefined(this.dmConstants.partnerInfo.partnerData.Contacts[0].FirstName)
            && this.dmConstants.partnerInfo.partnerData.Contacts[0].FirstName !== "") {
            this.dataModelService.setIn(Sections.UserInfoRegistration, ['userInfo', 'firstName'], this.dmConstants.partnerInfo.partnerData.Contacts[0].FirstName);
        }

        /// check for some constraints
        if (this.dmConstants.partnerInfo
            && this.dmConstants.partnerInfo.partnerData
            && this.dmConstants.partnerInfo.partnerData.Contacts
            && this.dmConstants.partnerInfo.partnerData.Contacts[0]
            && !_.isNull(this.dmConstants.partnerInfo.partnerData.Contacts[0].LastName)
            && !_.isUndefined(this.dmConstants.partnerInfo.partnerData.Contacts[0].LastName)
            && this.dmConstants.partnerInfo.partnerData.Contacts[0].LastName !== "") {
            this.dataModelService.setIn(Sections.UserInfoRegistration, ['userInfo', 'lastName'], this.dmConstants.partnerInfo.partnerData.Contacts[0].LastName);
        }

        /// check for some constraints
        if (this.dmConstants.partnerInfo
            && this.dmConstants.partnerInfo.partnerData
            && this.dmConstants.partnerInfo.partnerData.Contacts
            && this.dmConstants.partnerInfo.partnerData.Contacts[0]
            && !_.isNull(this.dmConstants.partnerInfo.partnerData.Contacts[0].EmailAddress)
            && !_.isUndefined(this.dmConstants.partnerInfo.partnerData.Contacts[0].EmailAddress)
            && this.dmConstants.partnerInfo.partnerData.Contacts[0].EmailAddress !== "") {
            this.dataModelService.setIn(Sections.UserInfoRegistration, ['userInfo', 'emailAddress'], this.cleanString(this.dmConstants.partnerInfo.partnerData.Contacts[0].EmailAddress.trim()));
            this.dmWidgetManagerService.setInField(Sections.DefaultRegistrationManagerId, Sections.UserInfoRegistration, "UserEmail", ['attributes', 'disable'], true);
        }

        /// check for some constraints
        if (this.dmConstants.partnerInfo
            && this.dmConstants.partnerInfo.partnerData
            && this.dmConstants.partnerInfo.partnerData.LegalCompanyName
            && !_.isNull(this.dmConstants.partnerInfo.partnerData.LegalCompanyName)
            && !_.isUndefined(this.dmConstants.partnerInfo.partnerData.LegalCompanyName)
            && this.dmConstants.partnerInfo.partnerData.LegalCompanyName !== "") {
            this.dataModelService.setIn(Sections.UserInfoRegistration, ['userInfo', 'legalCompanyName'], this.dmConstants.partnerInfo.partnerData.LegalCompanyName);
            this.dmWidgetManagerService.setInField(Sections.DefaultRegistrationManagerId, Sections.UserInfoRegistration, "LegalCompanyName", ['attributes', 'disable'], true);
        }

        /// check for some constraints
        if (this.dmConstants.partnerInfo
            && this.dmConstants.partnerInfo.partnerData
            && this.dmConstants.partnerInfo.partnerData.Contacts
            && this.dmConstants.partnerInfo.partnerData.Contacts[0]) {
            this.dmConstants.isPrimary = this.dmConstants.partnerInfo.partnerData.Contacts[0].IsPrimary;
        }

        /// check for some constraints
        if (userInfo.EnableUserNameAsEmailFeatureSetting && userInfo.BuyerInvitationDetails.UserName != ""
            && !_.isEmpty(userInfo.BuyerInvitationDetails.UserName)
            && !_.isUndefined(userInfo.BuyerInvitationDetails.UserName)
            && !_.isNull(userInfo.BuyerInvitationDetails.UserName)) {
            this.dataModelService.setIn(Sections.UserInfoRegistration, ['userInfo', 'userName'], userInfo.BuyerInvitationDetails.UserName.trim());
            this.dmWidgetManagerService.setInField(Sections.DefaultRegistrationManagerId, Sections.UserInfoRegistration, "UserName", ['attributes', 'disable'], true);
            this.callGlobalLoader("loadderstart");
            let validateUserbool = await this.checkDuplicateUsernameNew(userInfo.BuyerInvitationDetails.UserName);
            let userInfoData = this.dataModelService.getById("UserInfoRegistration");
            userInfoData.userInfo.validateUser = validateUserbool.store;
            this.callGlobalLoader("loadderEnd");
            this.ExisingUserEmailPCCheckNew(userInfo.BuyerInvitationDetails.UserName);
        }

    }
    callNotification(error: any) {
        let message = new Message(error, [], '', { selected: false });
        this.channelService.broadcast(message);
    }
    callGlobalLoader(loaderinfo: any) {
        let message = new Message(loaderinfo, [], '', { selected: false });
        this.channelService.broadcast(message);
    }
    /// ASCII Check for Email
    cleanString(input: string) {
        if (input) {
            var output = "";
            for (var i = 0; i < input.length; i++) {
                if (input.charCodeAt(i) <= 127) {
                    output += input.charAt(i);
                }
            }
            return output;
        }
        return input;
    }

    //this method sends message to entry-v2 plugin 
    // then entry-v2 plugin send message to recaptcha plugin to reset captcha.
    // In case of direct link registration only
    resetCaptcha(){

        let message = new Message("recaptchaReload", [], '', { selected:true });
        this.channelService.broadcast(message);

    }
}